"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _features = require("../../../../../Shared/store/features");

var BudgetSettingsItem = function BudgetSettingsItem(_ref) {
  var label = _ref.label,
      minPrice = _ref.minPrice,
      maxPrice = _ref.maxPrice,
      campaign = _ref.campaign;
  var min = (0, _ramda.defaultTo)(campaign === null || campaign === void 0 ? void 0 : campaign.budgetSettings.minPrice, minPrice);
  var max = (0, _ramda.defaultTo)(campaign === null || campaign === void 0 ? void 0 : campaign.budgetSettings.maxPrice, maxPrice);
  var multipleValues = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MULTIPLE_GIFT_CARD_VALUES));
  var rangeLabel = min === max ? min : "".concat(min, " - ").concat(max);

  if (!multipleValues || !(0, _ramda.is)(Number, min) && !(0, _ramda.is)(Number, max)) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("b", null, label, ":"), " $", rangeLabel);
};

var _default = BudgetSettingsItem;
exports.default = _default;